import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OneFieldDialogComponent } from 'src/app/dialogs/onefield-dialog/onefield-dialog.component';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import { ServicesService } from 'src/app/services/services.service';

@Component({
  selector: 'app-admin-service-code',
  templateUrl: './admin-service-code.component.html',
  styleUrls: ['./admin-service-code.component.scss']
})
export class AdminServiceCodeComponent implements OnInit {

  public codeDates: string[] = [];
  public currentDate = '';

  private theCode: CNServiceCode;
  private dates: any;

  constructor(private services: ServicesService, private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  @Input() set code(aCode: CNServiceCode) {
    if (aCode) {
      this.theCode = aCode;
      this.currentDate = this.theCode.getProperty('codedate');
      this.services.codeVersion(this.theCode).subscribe(allVersions => {
        this.codeDates = [];
        this.dates = {};
        const timestamps = Object.keys(allVersions);
        timestamps.forEach(timestamp => {
          const theDate = allVersions[timestamp].properties.codedate;
          this.codeDates.push(theDate);
          this.dates[theDate] = allVersions[timestamp];
        });
        console.log(allVersions);
      });
    }
  }

  get code(): CNServiceCode {
    return this.theCode;
  }

  selectDate(aDate: string) {

  }

  saveCode(): void {
    this.services.updateCode(this.theCode).subscribe();
  }

  addCustomField(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Nouveau champs extra',
      fieldName: 'extra',
      okMsg: 'Ajouter'
    };
    const dialogRef = this.dialog.open(OneFieldDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result !== false) {
        this.theCode.addExtra(result);
      }
    });
  }

}
